import React from 'react';

const Loading = props => {
  return (
    <div id='loading'>Loading...</div>
  )
}

export default Loading
